import { type BoundaryGroup } from '~/boundary/boundary.types';
import type { DemographicsDataProvider } from '~/store/demographics/demographics.types';

export const checkIfBoundaryGroupIsWMSGenerated = (boundaryGroup: BoundaryGroup) => {
  return (boundaryGroup?.wms.territoriesCount ?? 0) > 0;
};

export const checkIfBoundaryGroupIsMOTGenerated = (boundaryGroup: BoundaryGroup) => {
  return (boundaryGroup?.mot.territoriesCount ?? 0) > 0;
};

export const isGeneralBoundaryGroup = (boundaryGroup: BoundaryGroup): boolean =>
  !boundaryGroup.provider;

export const getCheckIsBoundaryGroupFromProvider = (provider: DemographicsDataProvider) => (
  boundaryGroup: BoundaryGroup,
): boolean => boundaryGroup.provider === provider;
